import { Link } from "react-router-dom";
import { getEntitiyTitle } from "./importHelper";

type CreditorsCell = {
  data: {
    importJobId: String;
    documentName: String;
  };
};
export const useCustomCellRenderers = () => {
  function getEntityName(entityId:string | number){
      return getEntitiyTitle(entityId)
  }
  const caseRenderers = {
    entityTypeCellRenderer: function (param: any) {
      return <>{getEntityName(param.data.entityType)}</>;
    },
    nameCellRenderer: function (param: CreditorsCell) {
      return (
        <>
          {
            <Link
              to={`./import/${param.data.importJobId}`}
              state={{ from: param.data.importJobId }}
            >
             <span className="text-bold-underline">{ param.data.documentName}</span> 
            </Link>
          }
        </>
      );
    },
  };
  return caseRenderers;
};
